import { Tree } from "antd";
import _ from "lodash";
import React, { useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { toast } from "react-toastify";
import styled from "styled-components";

import { Button } from "@components/Button";
import ErrorValidate from "@components/ErrorValidate";
import { StyledInput } from "@components/Input";
import { Text } from "@components/Text";
import { COLOR_DARK, COLOR_GREEN, COLOR_WHITE } from "@static/COLORS";
import { KEY_DASHBOARD } from "@static/PERMISSION_KEY";
import { PERMISSION_LIST } from "@static/PERMISSION_LIST";
import { filterPermissions } from "@utils/filterPermissions";
import { fetchAPI } from "@utils/https/fetchAPI";
import { VALIDATE_RULES } from "@validate/index";

const FormContainer = styled.form`
  width: 100%;
  height: 100%;
  display: flex;
  position: relative;
  flex-direction: column;
  gap: 2px;
`;

const Line = styled.div`
  width: 100%;
  height: 1px;
  margin-bottom: 8px;
  background-color: rgba(0, 0, 0, 0.1);
`;

const SectionTree = styled.div`
  height: calc(100% - 58px);
  overflow-y: auto;
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  height: 40px;
`;

export const FormCreate = ({
  setDataList = () => undefined,
  setIsModalVisible,
  dataList,
  categoryCustomerId,
  userType,
}) => {
  const { control, handleSubmit } = useForm();
  const [checkedPermissions, setCheckedPermissions] = useState([KEY_DASHBOARD]);
  const filteredPermissions = filterPermissions({
    permissions: PERMISSION_LIST,
    userType,
  });

  const onHandleCreate = async (data) => {
    const name = _.get(data, ["name"]);
    const resp = await fetchAPI({
      method: "post",
      path: "/api/v1/roles-create",
      isAuth: true,
      data: {
        name,
        permissions: checkedPermissions,
        category_customer_id: null,
      },
    });
    if (_.get(resp, ["status"])) {
      const results = _.chain(resp).get(["result"]).value();
      toast.success("Create Role Success.");
      setIsModalVisible((prev) => ({ ...prev, isOpen: false }));

      const createdRole = _.chain(results)
        .thru((item) => {
          return {
            ...item,
            permissions: JSON.parse(_.get(item, ["permissions"])),
          };
        })
        .value();
      const updateData = _.chain(dataList)
        .thru((list) => {
          return [createdRole, ...list];
        })
        .map((item, index) => {
          return { ...item, key: index + 1, index: index + 1 };
        })
        .value();
      setDataList(updateData);
    }
  };

  return (
    <FormContainer onSubmit={handleSubmit(onHandleCreate)} autoComplete="off">
      <Line />
      <Controller
        name="name"
        control={control}
        rules={_.get(VALIDATE_RULES, ["required"])}
        render={({ field, fieldState: { error } }) => (
          <div>
            <Text
              color={COLOR_DARK}
              fontSize="14px"
              style={{ marginBottom: 4, marginLeft: 4 }}
            >
              Name
            </Text>
            <StyledInput {...field} size="large" placeholder="name" />
            <ErrorValidate justify="start" error={error} />
          </div>
        )}
      />
      <SectionTree>
        <Tree
          treeData={filteredPermissions}
          checkStrictly={true}
          checkable
          defaultExpandAll
          onCheck={(e) => setCheckedPermissions(_.get(e, ["checked"]))}
          checkedKeys={checkedPermissions}
        />
      </SectionTree>
      <ButtonContainer>
        <Button
          type="submit"
          color={COLOR_GREEN}
          fontColor={COLOR_WHITE}
          fontSize="16px"
          padding="5px 20px"
        >
          Save
        </Button>
      </ButtonContainer>
    </FormContainer>
  );
};
